/* eslint-disable no-unused-vars */
import { useId } from 'react';
import { useSelector } from 'react-redux';
import { revenueReportsAPI } from 'services/reports.service';
import { useCallback, useRef } from 'react';
import { Search, Buttons } from 'components';
import { Search as SmallSearchIcon, ExportIcon } from 'assets/icons';
import { useDebounce } from 'utils';
import { useSignal, useComputed } from '@preact/signals-react';
import * as S from './SearchAppPanel.styled';
import { DropDownMenu } from './DropDownMenu';
import { publisherReportsRequestTypes } from 'constants';
import { FilterBtn } from './filter/FilterBtn';

export const SearchAppPanel = ({
  appNumberIsSelected,
  toggleSelectedAppNumber,
  currentRequestType$,
  placementList$,
  countryList$,
  advertiserList$,
  handleExport,
}) => {
  const showAppName = useSelector((state) => state.auth.show_app_name);
  const periodFrom = useSelector((state) => state.reports.selectedDateRangeReports.from);
  const periodTo = useSelector((state) => state.reports.selectedDateRangeReports.to);
  const searchId = useId();
  const exportBtnId = useId();

  const { isLoading, isError } = revenueReportsAPI.useGetReportQuery({
    to: periodTo,
    from: periodFrom,
    type: publisherReportsRequestTypes.applications,
  });
  const containerRef = useRef(null);

  const searchRef = useRef(null);
  const searchValue$ = useSignal('');
  const debouncedSearchValue = useDebounce(searchValue$.value, 500);
  const dropDownIsOpen$ = useSignal(false);

  const handleClickToInputBox = useCallback(() => {
    console.log('onFocus');
    // dropDownIsOpen$.value = true;
  }, []);

  const handleOnChange = useCallback(
    (e) => {
      if (isLoading || isError) return;
      searchValue$.value = e.target.value;
    },
    [isLoading, isError],
  );

  const handleClickToSearchBar = useCallback(() => {
    if (isError || isLoading) return;
    dropDownIsOpen$.value = true;
  }, [isError, isLoading]);

  const showFilterBtn$ = useComputed(() => {
    switch (currentRequestType$.value) {
      case 'advertiser':
        return true;
      case 'applications':
        return true;
      case 'applications_placements':
        return true;
      case 'country':
        return true;
      case 'country_placements':
        return true;
      case 'date':
        return false;
      case 'placement':
        return true;
      case 'placement_country':
        return true;
      default:
        return false;
    }
  });

  return (
    <S.Container>
      <S.SearchBox ref={containerRef} onClick={handleClickToSearchBar}>
        <Search
          onFocus={handleClickToInputBox}
          ref={searchRef}
          id={searchId}
          onChange={handleOnChange}
          value={searchValue$?.value}
          placeholder={showAppName ? 'Search Application' : 'Search App ID'}
          rightIconOnClick={(event) => {
            searchValue$.value = '';
          }}
          style={
            dropDownIsOpen$.value === true
              ? { zIndex: '900000', position: 'relative' }
              : { position: 'relative' }
          }
          Icon={() => <SmallSearchIcon />}
        />
      </S.SearchBox>
      {dropDownIsOpen$.value && (
        <DropDownMenu
          dropDownIsOpen$={dropDownIsOpen$}
          containerRef={containerRef}
          searchValue={debouncedSearchValue}
          appNumberIsSelected={appNumberIsSelected}
          toggleSelectedAppNumber={toggleSelectedAppNumber}
          searchValue$={searchValue$}
        />
      )}

      <FilterBtn
        showFilterBtn$={showFilterBtn$}
        placementList$={placementList$}
        countryList$={countryList$}
        advertiserList$={advertiserList$}
      />
      <Buttons.QuaternaryNormal
        id={exportBtnId}
        icon={<ExportIcon />}
        isDisabled={isLoading || isError}
        onClick={(event) => {
          event.stopPropagation();
          handleExport();
        }}
      >
        Export
      </Buttons.QuaternaryNormal>
    </S.Container>
  );
};
